import { Button, Stack, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ flexGrow: 1, py: 12, alignItems: "center", justifyContent: "center" }}>
      <Typography variant="h2" sx={{ fontWeight: 700, color: "text.disabled" }}>
        404
      </Typography>
      <Typography variant="h4">{t("notFound.title")}</Typography>
      <Typography color="text.secondary" sx={{ maxWidth: "40ch", textAlign: "center" }}>
        {t("notFound.message")}
      </Typography>
      <Button component={Link} to="/" variant="contained" size="large" sx={{ mt: 2 }}>
        {t("notFound.backToDashboard")}
      </Button>
    </Stack>
  );
};
